"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagMX = function FlagMX(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-56.47,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H-56.47Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "137.53",
    y: "1",
    width: "136.53",
    height: "268.36",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H80.07V-122H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,18.5,11.8,24.59v6.09h6.09Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffd250"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,45.9a3,3,0,0,1-3.05-3V30.68a3,3,0,1,1,6.09,0V42.86a3,3,0,0,1-3,3Zm0,0",
    transform: "translate(194 123)",
    fill: "#00c3a0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,33.72a47.71,47.71,0,0,1-32.52-13,3,3,0,0,1-.16-4.3,3,3,0,0,1,4.3-.16A41.65,41.65,0,0,0,11.8,27.63,41.68,41.68,0,0,0,40.18,16.27a3,3,0,0,1,4.14,4.46,47.71,47.71,0,0,1-32.52,13Zm0,0",
    transform: "translate(194 123)",
    fill: "#00c3a0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,45.9a39.45,39.45,0,0,1-21.87-6.59l3.37-5.08a34,34,0,0,0,37,0l3.37,5.08A39.48,39.48,0,0,1,11.8,45.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#00aadc"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7,4.79.25,15.2-.89,18.62l17.51-4.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#732d37"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-6.84,22c-8,0-17.71-6.77-20.27-21.87l6-1C-19,11.64-11.25,15.89-6.62,15.88c1.42,0,2.91-.53,3-1.54.13-1.2.16-1.48-3-2.56A11,11,0,0,1-11.68,9c-5.57-6.37,2-13.1,5.59-16.33.64-.57.91-1.06.84-1.24A3.27,3.27,0,0,0-8-9.92c-3.87,0-6.81-2.18-7.66-5.7a8.12,8.12,0,0,1,4-9.12l2.79,5.41a2.13,2.13,0,0,0-.85,2.27c.07.31.26,1,1.74,1,3.73,0,7.28,2.2,8.43,5.23C.93-9.49,1.68-6.14-2-2.83-6,.74-8.42,3.43-7.09,4.94A8,8,0,0,0-4.66,6c2.75.93,7.85,2.65,7.12,9-.46,4-4,6.8-8.91,6.93Zm0,0",
    transform: "translate(194 123)",
    fill: "#aad264"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.89-11.95S24-24.13,11.8-30.22c0,0,42.63-6.09,36.54,48.72-4-3.2-9.93-9-12.05-13.71L17.89-5.86Zm0,0",
    transform: "translate(194 123)",
    fill: "#874150"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8.23,42.25,18.5,30.07,24.59,11.8,6.32Zm0,0",
    transform: "translate(194 123)",
    fill: "#732d37"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-.38-18a6.09,6.09,0,0,1,6.09,6.09h0A11.94,11.94,0,0,0,3.47,1.83L4.84,4.59a12.2,12.2,0,0,0,2.24,3.1L24,24.59V16.17A67.57,67.57,0,0,0,16.85-14,18.27,18.27,0,0,0,.51-24.13H-.38Zm0,0",
    transform: "translate(194 123)",
    fill: "#783c46"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-.38-24.13-6.47-18v6.09S.77-15.62,3.21-16.8a2.2,2.2,0,0,0,.42-3.68c-.76-.72-4-3.65-4-3.65Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffd250"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,58.08A51.82,51.82,0,0,1-40,6.32h6.09a45.68,45.68,0,0,0,91.36,0h6.09A51.83,51.83,0,0,1,11.8,58.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#aad264"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-29.41,24.39a4.13,4.13,0,0,1-4.13,4.13,4.13,4.13,0,0,1-4.14-4.13,4.13,4.13,0,0,1,4.14-4.13,4.12,4.12,0,0,1,4.13,4.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-20.27,39a4.14,4.14,0,0,1-4.14,4.13A4.13,4.13,0,0,1-28.54,39a4.13,4.13,0,0,1,4.13-4.13A4.14,4.14,0,0,1-20.27,39Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-5.43,50a4.13,4.13,0,0,1-4.14,4.13A4.12,4.12,0,0,1-13.7,50a4.13,4.13,0,0,1,4.13-4.13A4.14,4.14,0,0,1-5.43,50Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M61.72,24.39a4.14,4.14,0,1,1-4.13-4.13,4.13,4.13,0,0,1,4.13,4.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M52.57,39a4.13,4.13,0,1,1-4.13-4.13A4.13,4.13,0,0,1,52.57,39Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M37.73,50a4.13,4.13,0,1,1-4.13-4.13A4.12,4.12,0,0,1,37.73,50Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.84,49H8.75a6.09,6.09,0,0,1,0-12.18h6.09a6.09,6.09,0,1,1,0,12.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffb478"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M36.29,4.79c2,6,6.34,11.42,12.05,13.71C54.43-36.31,11.8-30.22,11.8-30.22c30.45,0,24.49,35,24.49,35Zm0,0",
    transform: "translate(194 123)",
    fill: "#9b4b5a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagMX;
exports["default"] = _default;